import BobotSoal from "./BobotSoal";
import CatatanTugas from "./CatatanTugas";
import EditFileDrive from "./EditFileDrive";
import ModalDetailWeekly from "./ModalDetailWeekly";
import ModalDrive from "./ModalDrive";
import ModalFile from "./ModalFile";
import ModalFilter from "./ModalFilter";
import ModalMateriH5P from "./ModalMateriH5P";
import ModalMateriVideo from "./ModalMateriVideo";
import ModalNoSoal from "./ModalNoSoal";
import ModalPekan from "./ModalPekan";
import ModalPreviewDrive from "./ModalPreviewDrive";
import ModalReviewCourse from "./ModalReviewCourse";
import PreviewSoal from "./PreviewSoal";
import SettingSiswa from "./SettingSiswa";
import SortTopik from "./SortTopik";
import TambahFolderDrive from "./TambahFolderDrive";
import TambahLiveClass from "./TambahLiveClass";
import TambahMateri from "./TambahMateri";
import TambahTopik from "./TambahTopik";
import TambahTugas from "./TambahTugas";
import ModalDiskusi from "./ModalDiskusi";
import UploadBuktiCourse from "./UploadBuktiCourse";
import ModalNoSoalTugasCourse from "./ModalNoSoalTugasCourse";
import ModalUjian from "./ModalUjian";
import ModalDescUjian from "./ModalDescUjian";
import BobotSoalUjian from "./BobotSoalUjian";
import ModalSoalCerita from "./ModalSoalCerita";
import ModalLihatNilai from "./ModalLihatNilai";
import ModalDetailBuku from "./ModalDetailBuku";
import ModalPreviewBook from "./ModalPreviewBook";
export {
  TambahTopik,
  TambahMateri,
  TambahLiveClass,
  SortTopik,
  ModalPekan,
  ModalDetailWeekly,
  ModalMateriVideo,
  SettingSiswa,
  TambahTugas,
  PreviewSoal,
  CatatanTugas,
  TambahFolderDrive,
  EditFileDrive,
  ModalPreviewDrive,
  ModalDrive,
  BobotSoal,
  ModalMateriH5P,
  ModalFile,
  ModalReviewCourse,
  ModalFilter,
  ModalNoSoal,
  ModalDiskusi,
  UploadBuktiCourse,
  ModalNoSoalTugasCourse,
  ModalUjian,
  ModalDescUjian,
  BobotSoalUjian,
  ModalSoalCerita,
  ModalLihatNilai,
  ModalDetailBuku,
  ModalPreviewBook,
};
